import { Container, CssBaseline, Grid, Paper, Typography } from '@mui/material'
import React from 'react'
import { demonstrationImages } from 'utils/images'
import { DemonstrationManualActions, DemonstrationManualStoreStates } from '.'
import { ManualImage, ManualVideo, Title } from './styles'

type OwnProps = {}

type DemonstrationManualProps = OwnProps & DemonstrationManualStoreStates & DemonstrationManualActions

const DemonstrationManual = (_: DemonstrationManualProps) => {
  const items = [
    {
      title: '1．撮影方法',
      sections: [
        [
          '読唇に適した撮影方法でない場合、顔の検出に失敗したり、誤認識の原因になります。以下の撮影方法に従って発話シーンを撮影してください。',
          '・発話開始の前後は口を閉じて下さい。録画開始になってから口を動かし始めてください。',
        ],
        [
          '・顔は画面中央を向いて発話してください。少し斜めを向く場合は認識できますが、横を向く場合は顔が検出できないため読唇できません。',
        ],
        [
          '・顔は画面中央に位置するようにして発話してください。カメラから離れすぎて顔が小さく写る場合、カメラに近すぎて顔が大きく写る場合は、顔が検出できないため読唇できません。',
        ],
        [
          '・撮影中はカメラを動かさないでください。',
          '・撮影を意識せずに、自然な発話速度、自然な口の動きで発話してください。早すぎる発話やゆっくりすぎる発話、口を大きく開けすぎる発話や口の開きが小さい発話は誤認識の原因になります。',
          '・撮影時間が短すぎる場合、あるいは長すぎる場合は処理できません。',
          '・認識対象の言葉以外を発話しないでください。',
        ],
      ],
    },
    {
      title: '２．利用方法',
      sections: [
        ['・声を出さなくても利用可能です。'],
        ['・音声を利用しませんので、騒音環境下でも利用可能です。'],
        ['・声を出さなくても認識できますので、静かな場所でも利用可能です。'],
        ['・他人撮りも可能です。'],
      ],
    },
  ]

  return (
    <Container>
      <CssBaseline />

      <Paper sx={{ mb: 2, p: 3 }}>
        <Grid container direction="column">
          {items.map(({ title, sections }, ii) => (
            <React.Fragment key={`item-${ii}`}>
              <Title>{title}</Title>
              {sections.map((section, si) => {
                const index = ii * 4 + si
                return (
                  <React.Fragment key={`section-${index}`}>
                    {section.map((text, key) => (
                      <Typography key={`section-item-${key}`}>{text}</Typography>
                    ))}
                    <Grid container sx={{ mx: 2 }}>
                      <ManualImage src={demonstrationImages[index]} alt={`demo-${index}`} />
                    </Grid>
                  </React.Fragment>
                )
              })}
            </React.Fragment>
          ))}

          <Title align="left">３．動画説明</Title>
          <ManualVideo
            title="demonstration-movie"
            src="https://www.youtube.com/embed/Oz7e0ODi28A"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </Grid>
      </Paper>
    </Container>
  )
}

export default DemonstrationManual
